import { connect } from "react-redux";
import React, { Component } from 'react';
import { Button } from "react-bootstrap";
import Loader from "../components/Loader";
import api from "../helpers/ApiClient";


class PostcodeCheckerDoorToDoorSG extends Component{
  constructor(props){
    super(props);
    this.state = {
      postcode: '',
      loading: false,
      city: '',
      invalidPostcode: false
    }
  }

  handlePostcodeChange = event => {
    this.setState({ postcode: event.target.value })
  }

  handlePostcode = () => {
    const { params : { vendor } } = this.props;
    let { postcode } = this.state;

    if (!postcode){
      return
    }

    this.setState({ loading: true });

    return api(`/api/lookup/doortodoor/postcode/sg`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        postcode,
        vendor
      })
    }).then(result => {

      this.setState({ loading: false });

      if(result){
        this.setState({
          result: result.result,
          city: result.city,
          invalidPostcode: false
        })

        window.parent.postMessage({ zone: result.result }, "https://giftr.sg");
      } else {
        this.setState({
          invalidPostcode: true,
          result: undefined
        })
      }
    })
  }

  handleEnterPress = (e) => {
    if(e.key === "Enter"){
      this.handlePostcode();
    }
  }

  render(){
    const {postcode, loading, city, invalidPostcode, result} = this.state;
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div>
              <label>Delivery Area Checker</label>
              <div className="row">
                <div className="col-xs-9">
                  <div className="form-group">
                    <input className="form-control" placeholder="Enter postcode" type="text" onChange={this.handlePostcodeChange} onKeyPress={this.handleEnterPress} />
                  </div>
                </div>
                <div className="col-xs-3">
                  <Button className="btn-postcode-checker" block disabled={loading} onClick={this.handlePostcode} >{loading ? 'Loading...' : 'Apply'}</Button>
                </div>
              </div>
              {
                loading && <Loader />
              }
              {
                !result && !invalidPostcode &&
                <div>
                  <p>Enter the postcode of shipping address to check on the delivery area & availability. Price may vary based on different zones.</p>
                </div>
              }
              {
                !loading && result &&
                <div>
                  <p>General Location: <b>{city}</b><br/>
                  Availability: <b>{result}</b></p>
                </div>
              }
              {
                invalidPostcode &&
                <div>
                  <p>You entered an invalid postcode. Please try again.</p>
                </div>
              }
              <hr/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(PostcodeCheckerDoorToDoorSG);
